export default __webpack_public_path__ + "static/media/rotate.cc2882db.svg";